import { removeFromArray } from "../../utils/utils";

const dbName = "slideshow";
const dbOrder = "slideshowOrder";
const storageName = "Slideshow";
const added = "SLIDESHOW_ADDED";
const adding = "SLIDESHOW_ADDING";
const ERROR = "SLIDESHOW_ADD_ERROR";
const clearStatus = "SLIDESHOW_ADD_CLEAR_STATUS";
const today = new Date();

export const newSlideshowphoto = (data) => {
  let orderData = null;
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const firebase = getFirebase();

    const currentTime = firebase.firestore.Timestamp.fromDate(today);
    const sspRef = firestore.collection(dbName).doc(data.id);
    const sspOrderRef = firestore.collection(dbOrder).doc("order");

    // Adding document
    sspOrderRef.get().then((doc) => {
      if (doc.exists) {
        orderData = doc.data();
      } else orderData = null;

      const sspOrder = {
        id: "order",
        modifiedAt: currentTime,
        order:
          orderData?.order?.length > 0
            ? !orderData?.order.includes(data.id)
              ? [...orderData?.order, data.id]
              : [...orderData?.order]
            : [data.id],
      };
      const batch = firestore.batch();
      const toFirestore = {
        id: data.id,
        fileName: data.fileName,
        modifiedAt: currentTime,
      };
      batch.set(sspOrderRef, sspOrder, { merge: true });
      batch.set(sspRef, toFirestore, { merge: true });

      !data.file && dispatch({ type: adding });

      batch
        .commit()
        .then(() => {
          if (data.file) {
            const storageRef = firebase.storage().ref();
            const uploadRef = storageRef
              .child(storageName)
              .child(data.fileName);

            return uploadRef.put(data.file).on(
              "state_changed",

              () => {
                dispatch({ type: adding });
              },

              (error) => {
                dispatch({ type: ERROR, error });
              },

              () => {
                uploadRef
                  .getDownloadURL()
                  .then(function (downloadURL) {
                    const sspImage = {
                      fileURL: downloadURL,
                    };

                    const batch = firestore.batch();
                    batch.update(sspRef, sspImage);
                    batch
                      .commit()
                      .then(() => {
                        dispatch({ type: added });
                        dispatch({ type: clearStatus });
                      })
                      .catch((err) => {
                        dispatch({ type: ERROR, err });
                      });
                  })
                  .catch((err) => {
                    dispatch({ type: ERROR, err });
                  });
              }
            );
          } else {
            dispatch({ type: added });
            dispatch({ type: clearStatus });
          }
        })
        .catch((e) => {
          dispatch({ type: ERROR, err: e });
        });
    });
  };
};

export const reorderSlideShowPhotos = (order) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const firebase = getFirebase();

    const sspOrder = firestore.collection(dbOrder).doc("order");
    const batch = firestore.batch();

    const currentTime = firebase.firestore.Timestamp.fromDate(today);
    const toFirestore = {
      id: "order",
      modifiedAt: currentTime,
      order,
    };
    batch.set(sspOrder, toFirestore, { merge: true });
    batch
      .commit()
      .then(() => {})
      .catch((e) => console.log(e));
  };
};

export const deleteSlideshowphoto = (data) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const firebase = getFirebase();
    const currentTime = firebase.firestore.Timestamp.fromDate(today);

    const ssp = firestore.collection(dbName).doc(data.id);
    const sspOrder = firestore.collection(dbOrder).doc("order");

    sspOrder
      .get()
      .then((doc) => {
        if (doc.exists) {
          const imageData = doc.data();
          const dbOrder = [...imageData.order];
          const newOrder = removeFromArray(dbOrder, data.id);
          const batch = firestore.batch();
          const toFirestore = {
            modifiedAt: currentTime,
            order: newOrder,
          };
          batch.set(sspOrder, toFirestore, { merge: true });

          batch
            .commit()
            .then(() => {
              ssp
                .delete()
                .then(() => {
                  if (data.fileName && data.fileURL) {
                    const storageRef = firebase.storage().ref();
                    const uploadRef = storageRef
                      .child(storageName)
                      .child(data.fileName);
                    uploadRef.delete();
                  }
                })
                .catch(() => dispatch({ type: ERROR }));
            })
            .catch((e) => console.log(e));
        } else console.log("Did Not Find Any");
      })
      .catch((e) => console.log(e));
  };
};
